__turbopack_context__.v({
  "className": "rfAvYW_className",
  "variable": "rfAvYW_variable",
});
